/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

export const mapFilterKeys = {
  "patient.name": "fname",
  "patient.family": "lname",
  "patient.dob": "birth",
  "location.name": "location",
  "patient.subLocation": "subLocation",
  mrn: "mrn",
  "device.modelName": "model",
  "device.serialNumber": "serial",
  "device.deviceType": "type",
  "device.manufacturerName": "manufacturer",
  interrogationStatus: "status",
  visitNumber: "visit",
  manufacturerAlert: "manufacturerAlert",
  id: "id",
  "readingPhysician.id": "assignedTo",
  "patient.followingPhysician.id": "followingPhysician",
  thirtyDayBillStatus: "thirtyStatus",
  nintyDayBillStatus: "nintyStatus",
  interrogationType: "interrogationType",
  nurseFollowUp: "nurseFollowUp",
  calibrated: "calibrated",
  "patient.insurance.insuranceType": "insurance",
  interrogationAccessHistory: "interrogationAccessHistory",
  priorityFlag: "alertType",
};

export const mapKeyFilters = {
  fname: { key: "patient.name", com: "$lk" },
  lname: { key: "patient.family", com: "$lk" },
  wildcard: { key: "patient.search", com: "$lk" },
  birth: { key: "patient.dob", com: "$eq" },
  location: { key: "location.name", com: "$eq" },
  subLocation: { key: "patient.subLocation", com: "$eq" },
  mrn: { key: "mrn", com: "$lk" },
  model: { key: "device.modelName", com: "$lk" },
  serial: { key: "device.serialNumber", com: "$lk" },
  type: { key: "device.deviceType", com: "$eq" },
  manufacturer: { key: "device.manufacturerName", com: "$eq" },
  status: { key: "interrogationStatus", com: "$eq" },
  visit: { key: "visitNumber", com: "$lk" },
  manufacturerAlert: { key: "manufacturerAlert", com: "$eq" },
  id: { key: "id", com: "$eq" },
  assignedTo: { key: "readingPhysician.id", com: "$eq" },
  followingPhysician: { key: "patient.followingPhysician.id", com: "$eq" },
  thirtyStatus: { key: "thirtyDayBillStatus", com: "$eq" },
  nintyStatus: { key: "nintyDayBillStatus", com: "$eq" },
  interrogationType: { key: "interrogationType", com: "$lk" },
  nurseFollowUp: { key: "nurseFollowUp", com: "$eq" },
  calibrated: { key: "calibrated", com: "$eq" },
  insurance: { key: "patient.insurance.insuranceType", com: "$eq" },
  interrogationAccessHistory: { key: "interrogationAccessHistory", com: "$eq" },
  alertType: { key: "priorityFlag", com: "$lk" },
};
